<template>
  <div>
    <v-container class="my-12 py-12">
      <v-card align="center" class="mx-auto" max-width="600px">
        <v-img class="black--text align-end" height="80px" src="../../assets/images/Qumulex.svg" contain></v-img>
        <v-card-text>
          <p class="title text--primary">QUMULEX OPERATIONS PORTAL</p>
        </v-card-text>
        <v-alert
          v-model="showLoginAlert"
          dismissible
          type="warning"
        >
          Login Required
        </v-alert>
        <div>
          <v-btn 
            @click="loginWithGoogle"
            large 
            color="primary darken-1"
            style="margin-bottom: 20px"
          >
            <v-icon left>
              fa-google
            </v-icon>
              log in with Google
          </v-btn>
        </div>
        <span style="background-color: white;">
          or
        </span>
        <v-divider 
          style="width: 90%; max-width: 360px; margin-bottom: 20px; margin-top: -10px;"
        />
        <form v-on:submit.prevent='onClick' class="mb-3">
          <v-container align="center">
            <v-row align="center" style="width: 80%; max-width: 320px" dense>
              <v-text-field 
                v-model="email" 
                type="email" 
                label="Email" 
                required
                :filled='true' 
                :solo='true' 
                @keydown="ClearErrorMessage"
                v-validate="'required|email|max:50'" 
                data-vv-name="email"
                :error-messages="errors.collect('email')"
              >
              </v-text-field>
            </v-row>
            <v-row align="center" style="width: 80%; max-width: 320px" dense>
              <v-text-field 
                v-model="password" 
                type="password"
                label="Password" 
                required 
                :filled='true'
                :solo='true' 
                @keydown="ClearErrorMessage"
                v-validate="'required|max:20|min:6'" 
                data-vv-name="password" 
                :error-messages="errors.collect('password')" 
              >
              </v-text-field>
            </v-row>
            <v-row align="center" style="width: 80%; max-width: 320px" dense>
              <v-col>
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <!-- this span allows me to get a tooltip on the button when it's disabled -->
                    <span v-on="on">
                      <v-btn 
                        type='submit' 
                        :disabled="errors.any()" 
                        large 
                        color="primary darken-1"
                      >
                        {{ isLoginMode ? "Login" : "Create New Account"}}
                      </v-btn>
                    </span>
                  </template>
                  <span>
                    {{ !isLoginMode ? 'The credentials you enter will be used to create your account' : 'Login to your existing portal account' }}
                  </span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-container>
          <v-spacer></v-spacer>
          <span class="red--text">{{errorMessage}}</span>
        </form>
        <v-card-text style="width: 50%">
          <a href="" v-on:click.prevent="PasswordReset">Forgot Password?</a>
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-subtitle class="body-2 grey lighten-2">
          {{ !isLoginMode ? 'Have a portal account already?' : 'Already a signed reseller?' }}
          <br>
          <a href="" v-if="isLoginMode" v-on:click.prevent="isLoginMode = !isLoginMode">Create login credentials</a>
          <a href="" v-else v-on:click.prevent="isLoginMode = !isLoginMode">Existing user login</a>
        </v-card-subtitle>
      </v-card>
    </v-container>
  </div>
</template>

<script>

export default {
  name: "Login",
  props: {
    app: Object,
    auth: Object,
    isLoggedIn: Boolean,
    alert: String
  },
  $_veeValidate: {
    validator: "new"
  },
  mounted() {
    console.log('Login mounted');
    this.app.reset(false);
    if (this.alert) {
      this.showLoginAlert = true;
      this.$router.replace('/login');
      setTimeout(() => {
        this.showLoginAlert = false;
      }, 2000);
    }
  },
  watch: {
    alert(val) {
      console.log("login::watch() alert ", val)
      if (val) {
        this.$router.replace('/login');
        this.showLoginAlert = true;
        setTimeout(() => {
          this.showLoginAlert = false;
        }, 2000);
      }
    }
  },
  data() {
    return {
      email: undefined,
      password: undefined,
      errorMessage: '',
      isLoginMode: true,
      showLoginAlert: false,
    }
  },
  methods: {
    onClick() {
      if (this.isLoginMode) {
        this.Login();
      } else {
        this.MakeNewAccount();
      }
    },

    loginWithGoogle() {
      this.auth.fbGoogleLogin(this.app.restApi,
        user => {
          this.loginCallback (user);
        });
    },

    // sign in to portal
    Login() {
      const user = {
        email: this.email,
        password: this.password
      };

      this.auth.fbEmailLogin(
        user, 
        this.app.restApi,
        user => {
          this.loginCallback (user);
        });
    },

    loginCallback(user) {
      if (Object.keys(user).length > 0) {
        console.log("Signed in successfully", this.$route);
        this.app.setUserProfile(user);
        console.log("Login::loginCallback() ", this.$route.params.from, sessionStorage.getItem('redirectPath'));
        this.$router.replace(sessionStorage.getItem('redirectPath') || '/home');
        sessionStorage.removeItem('redirectPath');
      } else {
        this.errorMessage = this.auth.lastErr;
        console.warn("either no user profile found, or there was an error signing in");
      }
    },

    // reset qumulex portal password
    PasswordReset() {
      const user = {
        email: this.email,
      };
      this.auth.PasswordReset( 
        user,
        val => {
          if (val === true) {
            // reset email sent
            this.app.reset();
            this.isLoginMode = true;
            this.$router.push("/login");
          }
          this.errorMessage = this.auth.lastErr;
        });
    },

    MakeNewAccount () {
      const user = {
        email: this.email,
        password: this.password
      };
      this.auth.CreateAccount( 
        user,
        val => {
          if (val === true) {
            // new account verification email sent
            this.app.reset();
            this.isLoginMode = true;
            this.$router.push("/login");
          }
          this.errorMessage = this.auth.lastErr;
        });
    },

    ClearErrorMessage() {
      this.errorMessage = '';
    }
  }
}
</script>

<style scoped>
.login-card-row {
  width: 80%; 
  max-width: 320px;
}
</style>